import { gql } from "@apollo/client";

const EMERSON_PRODUCT_SEARCH_RESULT_OPEN = gql`
  fragment EmersonProductSearchResultOpen on Product {
    id
    _legacyId
    name
    slug
    description
    variantCount
    heatSensitive
    eqpLevel
    containsCbd @skip(if: $isUnauthenticated)
    brand {
      id
      name
    }
    availableOrMasterVariant {
      id
      descriptor
      image
      imageNew
      msrp
      sku
      emersonVariantId
      name
      isNew
    }
  }
`;

export { EMERSON_PRODUCT_SEARCH_RESULT_OPEN };
